import axios from 'axios';

import { charsheetAPI, TABLE_SPELLS } from '../../../globals.js';

// ************************************************
//
// getAllSpells - gets the full spell list from DynamoDB via API

const spellTable = TABLE_SPELLS

async function GET_ALL_SPELLS ( classChoices = ['Cleric, Druid, Mage, Illusionist, MagicItems'], caller='Unknown' ) {

    console.log('**** GET ALL SPELLS ****  Caller: ', caller)

    try {
        const res = await axios.get( charsheetAPI + '?TableName=' + spellTable + '&Class=all' );
        console.log('All Spells:', res.data)
        return res.data
    } catch(e) {
        console.error('GET_ALL_SPELLS error:', e);
        return []
    }

}

export default GET_ALL_SPELLS
